import { render, staticRenderFns } from "./business-information.vue?vue&type=template&id=dc40f088&scoped=true&"
import script from "./business-information.vue?vue&type=script&lang=js&"
export * from "./business-information.vue?vue&type=script&lang=js&"
import style0 from "./business-information.vue?vue&type=style&index=0&id=dc40f088&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc40f088",
  null
  
)

export default component.exports